module.exports = __webpack_public_path__ + "img/icon-bag.51e57b1d.svg";